import React, { useMemo } from "react";
import PropTypes from "prop-types";

function ReviewStars({ stars }) {
  if (stars === undefined) return null;
  const starArr = useMemo(() => new Array(5).fill(1).map((_, i) => i), []);
  return (
    <>
      {starArr.map((i) => (
        <span key={i}>
          {i < stars ? (
            <span>&#x2605;</span>
          ) : (
            <span className="tw-opacity-50">&#9734;</span>
          )}
        </span>
      ))}
    </>
  );
}

ReviewStars.propTypes = {
  stars: PropTypes.number,
};

ReviewStars.defaultProps = {
  stars: undefined,
};

export default React.memo(ReviewStars);
